import './styles.css';

type ModuleActionsProps = { children?: React.ReactNode };

export function ModuleActions({ children }: ModuleActionsProps) {
  return <div className="Module-actions">{children}</div>;
}
